export default __webpack_public_path__ + "static/media/google.d3ed5ca9.svg";